export enum EmploymentStatusEnum{
   FULL_TIME_CONTRACT = 'FULL TIME CONTRACT',
   FULL_TIME_INTERN = 'FULL TIME INTERNSHIP',
   FULL_TIME_PERMANENT = 'FULL TIME PERMANENT',
   PART_TIME_CONTRACT = 'PART TIME CONTRACT',
   PART_TIME_INTERN = 'PART TIME INTERNSHIP',
   PART_TIME_PERMANENT = 'PART TIME PERMANENT'
}